var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import Button from "../../Button";
export var SubmitChallenge = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var PoseCanvas = styled.canvas(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n"], ["\n  position: absolute;\n"])));
export var TryAgain = styled(Button)(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
export var ImagePreview = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: 100%;\n  height: 60%;\n"], ["\n  width: 100%;\n  height: 60%;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
